const sessionStorageMiddleware = (storeAPI) => (next) => (action) => {
  const result = next(action)

  // Después de que se procesa la acción, sincroniza el estado relevante en sessionStorage.
  const state = storeAPI.getState()
  if (state.finance) {
    sessionStorage.setItem('financeState', JSON.stringify(state.finance))
  }
  if (state.steps) {
    sessionStorage.setItem('stepsState', JSON.stringify(state.steps))
  }
  if (state.payment) {
    sessionStorage.setItem('paymentState', JSON.stringify(state.payment))
  }
  if (state.scheduling) {
    sessionStorage.setItem('schedulingState', JSON.stringify(state.scheduling))
  }

  return result
}

export default sessionStorageMiddleware
